import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="relative max-w-4xl mx-auto rounded-2xl overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20background%20with%20soft%20golden%20amber%20hues%2C%20smooth%20curves%2C%20minimalist%20texture%2C%20warm%20glow%20effect%2C%20clean%20composition%2C%20artistic%20design%2C%20no%20text&width=1200&height=500&seq=cta-bg-2026&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-foreground-950/65" />
        </div>

        <div className="relative z-10 p-10 md:p-14 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
            还没有找到回家的路？
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-8 max-w-md mx-auto leading-relaxed">
            收藏本导航站，随时获取草榴社区最新可用地址，再也不用担心迷路
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zuixin-dizhi"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-link text-lg" />
              立即查看地址
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-100 border border-background-300/30 rounded-lg text-sm font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line text-lg" />
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}